import React from "react";

const PopupHoraTerminosCondiciones = ({ filePath, onClose }) => {

  const styles = {
    modal: {
      display: "block",
      backgroundColor: "rgba(0, 0, 0, 0.5)",
    },
    modalDialog: {
      maxWidth: "700px",
    },
    closeButton: {
      position: "absolute",
      top: "10px",
      right: "10px",
      background: "transparent",
      border: "none",
      fontSize: "24px",
      cursor: "pointer",
    },
    modalContent: {
      padding: "20px",
    },
    scrollableContent: {
      height: "600px",
      overflowY: "auto",
    },
    heading1: {
      textAlign: "center",
      fontSize: "1.5rem",
      marginBottom: "20px",
    },
    heading2: {
      marginTop: "20px",
      fontSize: "1.25rem",
    },
    table: {
      width: "100%",
      borderCollapse: "collapse",
      margin: "20px 0",
    },
    th: {
      border: "1px solid #ddd",
      padding: "10px",
      backgroundColor: "#f4f4f4",
      textAlign: "left",
    },
    td: {
      border: "1px solid #ddd",
      padding: "10px",
      textAlign: "left",
    },
    ul: {
      marginTop: "10px",
      paddingLeft: "20px",
    },
    li: {
      marginBottom: "10px",
    },
    signatureSection: {
      marginTop: "40px",
    },
    signatureLine: {
      marginTop: "20px",
      borderTop: "1px solid #000",
      width: "50%",
    },
  };

  return (
    <div>
      <div
        className="modal fade show"
        style={styles.modal}
        tabIndex="-1"
        role="dialog"
      >
        <div
          className="modal-dialog modal-dialog-centered"
          role="document"
          style={styles.modalDialog}
        >
          <div className="modal-content modal-succes">
            <div className="modal-body body-cita-confirmada" style={styles.modalContent}>
              <button onClick={onClose} style={styles.closeButton}>
                &times;
              </button>
              {/* Mostramos el contenido */}
              <div style={styles.scrollableContent}>
                <h1 style={styles.heading1}>
                  CONSENTIMIENTO INFORMADO DE USO DE DATOS PERSONALES Y COMUNICACIONES COMERCIALES
                </h1>

                <p>
                  Por medio del presente documento, <strong>LUXOTTICA OF CHILE S.A.</strong> (“Luxottica”), Rol Único
                  Tributario N°96.891.370-0, en su calidad de responsable del tratamiento de datos, pone a disposición de los
                  clientes, la presente <strong>“Autorización para el Tratamiento de Datos Personales”</strong> (“Autorización”)
                  para que podamos procesar sus Datos Personales de conformidad con la normativa vigente sobre Protección de
                  Datos Personales (Ley N°19.628 y todas aquellas normas que complementen y/o deroguen las disposiciones
                  contenidas en dicha ley).
                </p>

                <h2 style={styles.heading2}>Finalidades y usos de los Datos Personales</h2>

                <table style={styles.table}>
                  <thead>
                    <tr>
                      <th style={styles.th}>Datos Personales y Datos Sensibles</th>
                      <th style={styles.th}>Finalidades</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td style={styles.td}>
                        Nombre completo<br />
                        Edad y teléfono<br />
                        Hábitos alimenticios, deportivos o vida cotidiana<br />
                        Antecedentes médicos o clínicos<br />
                        Estado de salud
                      </td>
                      <td style={styles.td}>
                        Realizar el examen visual para diagnosticar alteraciones visuales y oculares. Cada parte del examen
                        visual completo proporciona información importante sobre la salud de los ojos.
                        <br />
                        Contribuyen a detectar a tiempo las enfermedades y a derivar al paciente al profesional indicado para
                        su diagnóstico y tratamiento.
                      </td>
                    </tr>
                  </tbody>
                </table>

                <p>
                  En caso de que no desee que sus Datos Personales sean tratados para estos fines, podrá manifestarlo antes de
                  realizar el examen visual.
                </p>

                <h2 style={styles.heading2}>Seguridad y Transferencia de los Datos Personales</h2>

                <p>
  Los Datos Personales y datos sensibles que usted proporcione serán tratados y resguardados con un alto estándar de
  seguridad y estricta confidencialidad para evitar su daño, pérdida, alteración, destrucción o el uso, acceso o tratamiento
  no autorizado, conforme a lo establecido en el Aviso de Privacidad:{" "}
  <a href="https://www.opv.cl/institucional/#politicas-privacidad" target="_blank" rel="noopener noreferrer">
    https://www.opv.cl/institucional/#politicas-privacidad
  </a>
  ,{" "}
  <a href="https://gmo.cl/politicas-de-privacidad" target="_blank" rel="noopener noreferrer">
    https://gmo.cl/politicas-de-privacidad
  </a>{" "}
  y{" "}
  <a href="https://www.econopticas.cl/politica-de-privacidad" target="_blank" rel="noopener noreferrer">
    https://www.econopticas.cl/politica-de-privacidad
  </a>
  . En cualquier caso, Luxottica ha adoptado medidas razonables para garantizar la conservación de la información únicamente
  durante el tiempo necesario para la finalidad con que se recopiló, para su procesamiento, o más tiempo si se exige en
  virtud de un contrato o legislación aplicable.
</p>

<p>
  Para llevar a cabo las legítimas finalidades antes señaladas, Luxottica podrá compartir sus datos personales con terceros
  encargados y/o con empresas de su grupo económico, los cuales pueden encontrarse dentro o fuera del país.
</p>

<h2>Derechos de los Titulares de Datos Personales</h2>

<p>
  Luxottica reconoce y garantiza el ejercicio de los derechos de acceso, rectificación, cancelación, oposición y demás
  contenidos en la Ley N°19.628.
</p>

<p>
  Para ejercer los derechos antes mencionados y/o para efectuar cualquier consulta o reclamo, el Titular de los Datos
  Personales deberá remitir una comunicación al correo electrónico{" "}
  <a href="mailto:derecho.arco@cl.luxottica.com">derecho.arco@cl.luxottica.com</a>, o a la dirección Av. Santa Clara N°249,
  Ciudad Empresarial, Huechuraba, Región Metropolitana, Chile. Las comunicaciones serán atendidas conforme al término legal
  señalado en las leyes de Protección de Datos Personales.
</p>

<p>
  En caso de que Luxottica no responda a las solicitudes en un tiempo prudente o las deniegue, los Titulares de los Datos
  tienen el derecho a recurrir ante los tribunales de justicia correspondientes.
</p>

<h2>Responsable del Tratamiento de Datos Personales</h2>

<p>
  <strong>LUXOTTICA OF CHILE S.A.</strong>
  <br />
  RUT: 96.891.370-0
  <br />
  Dirección: Av. Santa Clara N°249, Ciudad Empresarial, Huechuraba, Región Metropolitana, Chile.
</p>

<p>
  Para obtener más información sobre nuestras prácticas de Tratamiento de Datos Personales, y si tiene alguna pregunta sobre
  esta Autorización, consulte nuestro Aviso de Privacidad, el cual se encuentra disponible en nuestro sitio o contáctenos
  por correo electrónico indicado arriba.
</p>

<h2>Autorización</h2>

<p>
  El Titular de los Datos Personales – o su representante legal en los casos que resulte procedente – manifiesta que ha leído
  y entendido la presente Autorización y otorga su consentimiento para el Tratamiento de sus Datos Personales y Datos
  Sensibles exclusivamente para las siguientes finalidades:
</p>

<ul>
  <li>Realizar el examen visual para diagnosticar alteraciones visuales y oculares y conocer su historial clínico.</li>
  <li>
    Recibir comunicaciones promocionales personalizadas, incluyendo información sobre ofertas, productos nuevos, servicios y
    otras campañas de marketing relacionadas con Luxottica.
  </li>
</ul>

<p>
  Asimismo, manifiesta que sus Datos Personales son exactos, auténticos y completos y por lo tanto reconoce que es el único
  responsable de la exactitud, veracidad y autenticidad de sus Datos Personales.
</p>

<p>
  Respecto de los Titulares de datos menores de 18 años, el representante legal de [nombre del menor de edad], [número de
  identificación del menor de edad], manifiesta que ha leído y entendido la presente autorización y otorga su consentimiento
  para el Tratamiento de los Datos Personales y Datos Sensibles del menor de edad exclusivamente para los fines aquí
  indicados.
</p>

<div className="signature-section">
  <div className="signature-line" style={{ marginTop: "20px", borderTop: "1px solid #000", width: "50%" }}></div>
  <p>
    <strong>NOMBRE COMPLETO:</strong>
  </p>
  <p>
    <strong>N° DE IDENTIFICACIÓN:</strong>
  </p>
</div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopupHoraTerminosCondiciones;
